import { styled } from '@mui/material/styles';
import ArrowUpIcon from './ArrowUpIcon';

export default styled(ArrowUpIcon)`
  transform: rotate(180deg);
  path {
    fill: ${({ theme }) => theme.palette.red}
  }
`;
